import { render } from "./consultation_notes.vue?vue&type=template&id=50bafdfc&scoped=true"
import script from "./consultation_notes.vue?vue&type=script&lang=js"
export * from "./consultation_notes.vue?vue&type=script&lang=js"

import "./consultation_notes.vue?vue&type=style&index=0&id=50bafdfc&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bafdfc"]])

export default __exports__